module.exports = __webpack_public_path__ + "6cdbc6af8e4d4838cd5e7c28d55f5ecb.ttf";